import React from "react"
import { Language } from "@/lib/i18n"

interface PrimaryBannerProps {
  title: React.ReactNode
  subtitle: React.ReactNode
}

export const PrimaryBanner: React.FC<PrimaryBannerProps> = ({
  title,
  subtitle
}) => {
  return (
    <div className="banner-primary">
      <div className="banner-primary-inner">
        <h1 className="banner-title min-w-0">
          {title}
        </h1>
        {subtitle && (
          <>
            <span className="hidden sm:inline mx-2 opacity-80">-</span>
            <p className="banner-subtitle">
              {subtitle}
            </p>
          </>
        )}
      </div>
    </div>
  )
}
